import React from "react";
import { NavLink } from "react-router-dom"

import "./Footer.css"


function Footer() {
    return(
        <div className="footerBox">

            <NavLink style={{ textDecoration: 'none',
             color: "black" }} to="/">
            <div>
            <img src="/images/magglass.png" />
            <p>Explore</p>
            </div>
            </NavLink>

            <NavLink style={{ textDecoration: 'none',
             color: "black" }} to="/appointments">
            <div>
            <img src="/images/calendar.png" />
            <p>Appointments</p>
            </div>
            </NavLink>
            
            <NavLink style={{ textDecoration: 'none',
             color: "black" }} to="/favourites">
            <div>
            <img src="/images/wishlist.png" />
            <p>Favourites</p>
            </div>
            </NavLink>

            <NavLink style={{ textDecoration: 'none',
             color: "black" }} to="/profile">
            <div>
            <img src="/images/account.png" />
            <p>Profile</p>
            </div>
           
            </NavLink>
        </div>
    )
}

export default Footer;